import React, { useState, useRef, useMemo, useEffect } from 'react';
import LS from '../../styles/layoutStyled';
import CS from '../../styles/componentStyled';
import styled from 'styled-components';
import InputModal from '../InputModal';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { userIdState } from '../../atom/TokenAtom';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
  lineMoveStateRecoil,
} from '../../atom/ModalAtom';
import {
  RoomInforDto,
  RoomPeopleDto,
  RoomPeoplesDto,
  LineDto,
} from '../../model/room.dto';
import { socketio } from '../../api/socket.api';
import { roomAPI } from '../../api/axiosIndex';
import { useParams } from 'react-router-dom';
import { Icon } from '../../component/Icon';

interface LineMoveProps {
  pickLineId: number | null;
  roomInforLine: LineDto[] | null;
  checkIdArray: string[];
  roomId: string;
  setCheckIdArray: (checkIdArray: string[]) => void;
  onListUpdate: () => void;
}

const LineMove = ({
  pickLineId,
  roomInforLine,
  checkIdArray,
  roomId,
  setCheckIdArray,
  onListUpdate,
}: LineMoveProps) => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const userSelectBoxRef = useRef<HTMLSelectElement>(null);

  const setModalState = useSetRecoilState(lineMoveStateRecoil);

  const [entryPossiblePeoples, setEntryPossiblePeoples] =
    useState<RoomPeoplesDto | null>(null);
  const [entryUserId, setEntryUserId] = useState('');
  const [entryUserName, setEntryUserName] = useState<string | undefined>('');

  const [moveLineList, setMoveLineList] = useState<LineDto[]>([]);
  const [selectLineId, setSelectLineId] = useState<string>('');

  const handleSelectBoxChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectLineId(e.target.value);
    userSelectBoxRef.current?.classList.add('selected');
  };

  const handleConfirm = async () => {
    if (selectLineId === '') {
      setError(blankMsg);
      return;
    }
    try {
      await roomAPI.putLineMove(
        roomId,
        Number(selectLineId),
        checkIdArray.map(Number),
      );
      socketio.entry(Number(pickLineId));
      socketio.entry(Number(selectLineId));
      setConfirm('라인 이동을 완료했습니다.');
      setCheckIdArray([]);
    } catch {
      setError('라인 이동에 실패했습니다.');
    }

    setModalState(false);
  };

  useEffect(() => {
    if (pickLineId) {
      const indexAddRoomInforLine = roomInforLine?.map((list, index) => ({
        ...list,
        lineIndex: index + 1,
      }));

      const pickExceptionLine = indexAddRoomInforLine?.filter(
        (list) => list.id !== pickLineId,
      );

      if (pickExceptionLine) {
        setMoveLineList(pickExceptionLine);
      }
    }
  }, [roomInforLine, pickLineId]);

  return (
    <>
      <InputModal
        title="라인 이동"
        onCancel={() => setModalState(false)}
        onConfirm={handleConfirm}
      >
        <ul className="input-wrap">
          <li>
            <h2>
              라인 리스트
              <span className="img-box">
                <Icon name="StarIcon" size="100%" color="#FF5151" />
              </span>
            </h2>
            <CS.SelectType1>
              <select
                ref={userSelectBoxRef}
                onChange={handleSelectBoxChange}
                value={selectLineId}
              >
                <option value="" disabled={true}>
                  라인을 선택해 주세요.
                </option>
                {moveLineList?.map((list) => (
                  <option value={list.id} key={list.id}>
                    {list.lineIndex}
                  </option>
                ))}
              </select>
              <span className="img-box">
                <Icon name="ArrowBottomIcon" size="100%" color="#D8D7DC" />
              </span>
            </CS.SelectType1>
          </li>
        </ul>
      </InputModal>
    </>
  );
};

export default LineMove;
